export default {
    confirmLabel: '确定',
    backspaceLabel: '退格',
    cancelKeyboardLabel: '收起键盘'
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/input-item/locale/zh_CN.js
// module id = 1857
// module chunks = 0